<template>
  <div>
    <div v-html="text"></div>
  </div>
</template>

<script>
import { infoHtml } from '@/pages/VisitasDomiciliares/CidadaosVisitados/utils.js'
export default {
  data() {
    return {
      text: infoHtml,
    }
  },
}
</script>

<style scoped lang="scss" src="@/pages/Documentacao/Views/stylesManual.scss" />
